import { makeVar } from '@apollo/client'

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
export const drawerToPrintVar = makeVar()
